module.exports = __webpack_public_path__ + "img/postgresql.9318272b.svg";